import { getAccountRequestDetails } from '@app/services/accountRepository';
import { isDefined } from '@app/utils/is';
import { skipToken, useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const ACCOUNT_REQUEST_DETAILS_QUERY_KEY = 'accountRequestDetails';

interface Props {
  id: string | undefined;
}

export const useAccountRequestDetails = ({ id }: Props) => {
  const { t } = useTranslation(['accounts']);

  return useQuery({
    meta: {
      errorMessage: t('accounts:account_request_details_load_failure'),
    },
    queryFn: isDefined(id) ? async () => getAccountRequestDetails(id) : skipToken,
    queryKey: [ACCOUNT_REQUEST_DETAILS_QUERY_KEY, { id }],
  });
};
